<template>
  <div>
    <h5><strong>Créer une transcription phonétique</strong></h5>
    
    <b-card class="mb-1">
      <b-card-text class="leftAlign">
        <p class="formGroupTitle">Transcription phonétique de la réponse</p>
        <b-input-group id="phoneticTranscriptionInput">
            <b-input-group-append>
              <b-button variant="info" v-b-modal.modal-2 data-backdrop="false">Clavier API</b-button>
            </b-input-group-append>
            <b-form-input type="text" size="lg" placeholder="Entrez une transcription" v-model="phoneticTranscription"></b-form-input>
        </b-input-group>
        <br>
        <b-form-group
            description="Choisir une valeur dans la liste déroulante"
            label="Réutiliser une transcription phonétique existante "
            label-for="phoneticTranscriptionSelect">
          <b-form-select id="phoneticTranscriptionSelect" :options="phoneticTranscriptonsList" size="lg" v-model="phoneticTranscription"></b-form-select>
        </b-form-group>
        <b-form-group  
            description="Choisir une valeur dans la liste déroulante"
            label="Information complémentaire"
            label-for="phoneticTranscriptionInfoSelect">
          <b-form-select id="phoneticTranscriptionInfoSelect" :options="phoneticTranscriptionComplementaryInfoList" v-model="phoneticTranscriptionInfo"></b-form-select>
        </b-form-group>
        <hr />
        <p class="formGroupTitle">Points d'enquête partageant cette transcription</p>
        <b-card bg-variant="light" >
          <b-card-text id="selectedinvEntries" class="overflow-auto">
            <span v-for="(d3Circle, index) in circleList" :key="d3Circle.id">
                {{ index !== 0 ? d3Circle.id : ''}}

                {{ index !== 0  && d3Circle.initialPhoneticTranscription !== 'forme phonétique non encore renseignée'
                && !d3Circle.replace ? ` (ajouté à ` + d3Circle.initialPhoneticTranscription + `)` : ''}} 
               
                {{ index !== 0 && d3Circle.initialPhoneticTranscription !== 'forme phonétique non encore renseignée'
                && d3Circle.replace ? ` (remplace ` + d3Circle.initialPhoneticTranscription + `)` : ''}}

                {{ index >= 1 && index < circleList.length -1 ? ', ' : ''}}
              </span>
          </b-card-text>
        </b-card>
             <b-form-text>
            (Maj + Clic) sur un point de la carte pour l'ajouter à ou le retirer de cette liste.
            Entre parenthèses la ou les formes phonétiques du PE si il en a déjà. 
        </b-form-text>   
        <br>
        <div style="text-align: center;">
          <b-button id="phoneticTranscriptionButton" :disabled="!phoneticTranscription" variant="success" @click="addPhoneticTranscription(), 
          $emit('closePhoneticTranscriptionCreation')">Enregistrer</b-button>
        </div>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "PhoneticTranscriptionsCreation",
  data() {
    return {
      phoneticTranscription: null,
      phoneticTranscriptonsList: [],
      phoneticTranscriptionInfo: null
    };
  },
  computed: {
    ...mapGetters({
      circleList: "getCircleList",
      inventoryEntriesList: "getAllInventoryEntries",
      phoneticTranscriptionComplementaryInfoList: 'getPhoneticTranscriptionComplementaryInfoList',
      apiKeyboardValue: 'getApiKeyboardValue'
    })
  },
  created() {
    this.$store.commit('UPDATE_ISPHONETICTRANSCRIPTIONEDITIONMODE', true)
    this.$store.commit('UPDATE_ISDELETEMODE', false)
    this.$store.dispatch('resetCircleList', true)
    this.setPhoneticTranscriptionsList()
  },
  watch:{ apiKeyboardValue(){ this.phoneticTranscription = this.apiKeyboardValue } },
  methods: {
    setPhoneticTranscriptionsList: function() {
      for (let i = 0; i < this.inventoryEntriesList.length; i++) {
        if (this.inventoryEntriesList[i].rousselotPhoneticForm != "forme phonétique non encore renseignée" 
        && !this.phoneticTranscriptonsList.includes(this.inventoryEntriesList[i].rousselotPhoneticForm)) {
          this.phoneticTranscriptonsList.push(this.inventoryEntriesList[i].rousselotPhoneticForm)
        }
      }
      this.phoneticTranscriptonsList.sort()
    },
    addPhoneticTranscription: function() {
      this.$store.dispatch("addPhoneticTranscription", { phoneticTranscription: this.phoneticTranscription, phoneticTranscriptionInfo: this.phoneticTranscriptionInfo })
    }
  } 
}
</script>
<style>
#phoneticTranscriptionButton,
#phoneticTranscriptionAlert {
  margin-bottom: 25px;
}
#selectedinvEntries {
  border: 0px;
  height: 100px;
}

</style>


// WEBPACK FOOTER //
// src/components/commons/sideBarViewer/phoneticTranscriptionsSideBar/PhoneticTranscriptionsCreation.vue